<template>
  <div class="member-activity" ref="main">
      <img :src="prefixImg + '01.jpg'" alt="" >
      <img :src="prefixImg + '02.jpg'" alt="" >
      <img :src="prefixImg + '03.jpg'" alt="" >
      <div class="sku" ref="sku">
            <img :src="prefixImg + grade + '-sku.png'" alt="" >
            <div class="cards">
                <div
                    :class="['ctn', 'card' + index]"
                    v-for=" (item, index) in currentSkus" 
                    :key="item.name"
                    @click="go(item.jumpUrl, item.courseId)"
                    :ref="'card' + index">
                   <img class="btn" :src="prefixImg+'button.png'"> 
                </div>
            </div>
      </div>
  </div>
</template>
<script>
import utils from "@/assets/js/utils";

const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
const grade = utils.getQueryString("grade");
const pageChannel = utils.getQueryString("pageChannel");
const jumpUrl = "hybird://method/openBukeListenCourseDetail?pageChannel=" + pageChannel;

export default {
  name: "memberActivity",
  data() {
    return {
      prefixImg:
        "https://appd.knowbox.cn/ss/activity/parent_frontend/parent_active/member_activity/",
      second: [
        {
          name: "格林童话",
          jumpUrl: jumpUrl,
          courseId: '67',
          isRecord: false,
        },
        {
          name: "安徒生童话",
          jumpUrl: jumpUrl,
          courseId: '68',
          isRecord: false,
        },
        {
          name: "中国古代寓言",
          jumpUrl: jumpUrl,
          courseId: '69',
          isRecord: false,
        },
        {
          name: "歪脑袋木头桩",
          jumpUrl: jumpUrl,
          courseId: '70',
          isRecord: false,
        },
        {
          name: "神笔马良",
          jumpUrl: jumpUrl,
          courseId: '71',
          isRecord: false,
        },
        {
          name: "小鲤鱼跳龙门",
          jumpUrl: jumpUrl,
          courseId: '72',
          isRecord: false,
        }
      ],
      third: [
        {
          name: "安徒生童话",
          jumpUrl: jumpUrl,
          courseId: '68',
          isRecord: false,
        },
        {
          name: "孤独的小螃蟹",
          jumpUrl: jumpUrl,
          courseId: '86',
          isRecord: false,
        },
        {
          name: "七色花",
          jumpUrl: jumpUrl,
          courseId: '65',
          isRecord: false,
        },
        {
          name: "拉封丹寓言",
          jumpUrl: jumpUrl,
          courseId: '75',
          isRecord: false,
        },
        {
          name: "伊索寓言",
          jumpUrl: jumpUrl,
          courseId: '76',
          isRecord: false,
        },
        {
          name: "一起长大的玩具",
          jumpUrl: jumpUrl,
          courseId: '77',
          isRecord: false,
        }
      ],
      other: [
        {
          name: "格林童话",
          jumpUrl: jumpUrl,
          courseId: '67',
          isRecord: false,
        },
        {
          name: "中国古代寓言",
          jumpUrl: jumpUrl,
          courseId: '69',
          isRecord: false,
        },
        {
          name: "安徒生童话",
          jumpUrl: jumpUrl,
          courseId: '68',
          isRecord: false,
        },
        {
          name: "伊索寓言",
          jumpUrl: jumpUrl,
          courseId: '76',
          isRecord: false,
        },
        {
          name: "小鲤鱼跳龙门",
          jumpUrl: jumpUrl,
          courseId: '72',
          isRecord: false,
        },
        {
          name: "神笔马良",
          jumpUrl: jumpUrl,
          courseId: '71',
          isRecord: false,
        }
      ],
      currentSkus: [],
      grade:'',
    };
  },
  methods: {
      go(jumpUrl, courseId){
          window.location.href = `${jumpUrl}&courseId=${courseId}`;
          utils.sendLog({
                token,
                version,
                source,
                extensionJson: {
                  event: 1,
                  courseId: courseId
                }
          }, 'hzxx916')
      },
      handleScroll(e){
        const bodyScrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
        const bodyClientHeight =  e.target.documentElement.clientHeight || e.target.body.clientHeight;
        const skuOffsetTop = this.$refs.sku.offsetTop;
        this.showRecord(bodyScrollTop, bodyClientHeight, skuOffsetTop);
      },
      /* 
        卡片曝光打点，
        在可视范围内打点，
        若已曝光，不再重复记录，
      */
     showRecord(bodyScrollTop, bodyClientHeight, skuOffsetTop){
        if(bodyScrollTop + bodyClientHeight > skuOffsetTop){
            for (let i = 0; i < this.currentSkus.length; i++) {
              const cardOffsetTop = this.$refs['card' + i ][0].offsetTop;
              const isVisual = bodyScrollTop + bodyClientHeight > cardOffsetTop + skuOffsetTop;
              if( isVisual && !this.currentSkus[i].isRecord ){
                // 卡片在可视范围内 && 没有打过点
                  utils.sendLog({
                        token,
                        version,
                        source,
                        extensionJson: {
                          event: 2,
                          courseId: this.currentSkus[i].courseId
                        }
                  }, 'hzxx916')
                 this.currentSkus[i].isRecord = true;
              }
            }          
        }
     }
  },
  created() {
    this.grade = grade;
    this.currentSkus = this[grade];
    window.addEventListener('scroll',this.handleScroll);
    utils.sendLog({
          token,
          version,
          source,
          extensionJson: {
            year: grade,
          }
    }, 'hzxx917')
  }
};
</script>
<style lang="scss" scoped>
.member-activity {
  background: #392d7e;
  img {
    width: 100%;
    display: block;
  }
  .sku {
    position: relative;
    top: 0;
    .cards {
      width: 100%;
      position: absolute;
      top: 0.3rem;
      left: 0;
      .ctn {
        width: 100%;
        height: 3.28rem;
        position: relative;
        .btn {
          width: 1.85rem;
          height: 0.57rem;
          position: absolute;
        }
        &:nth-child(odd) {
          .btn {
            right: 2.24rem;
            top: 2.24rem;
          }
        }
        &:nth-child(even) {
          .btn {
            left: 0.65rem;
            top: 2.24rem;
          }
        }
      }
    }
  }
}
</style>
